<template>
  <div class="media-dialog" v-if="isVisible" v-loading="isBusy">
    <div class="media-dialog__header">
      <button @click="close" class="border-0 bg-transparent">
        <i class="fas fa-2x fa-times"></i>
      </button>
    </div>
    <div class="media-dialog__body text-left message-content">
      {{ getBody }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body: null,
      isBusy: false,
      message: null,
      url: null,
    };
  },

  computed: {
    /**
     * @return {String}
     */
    getBody() {
      return this.body;
    },

    /**
     * @return {boolean}
     */
    isVisible() {
      return !_.isEmpty(this.message);
    },
  },

  methods: {
    /**
     * @param {String} body
     * @return {void}
     */
    onShow({url, message}) {
      this.url = url;
      this.message = message;

      this.load();
    },

    /**
     * @return {void}
     */
    load() {
      this.isBusy = true;
      axios.post(this.url, this.getForm())
        .then(this.onSuccess)
        .catch(this.handleErrorResponse)
        .then((isBusy = false) => this.isBusy = isBusy);
    },

    /**
     * @param data
     */
    onSuccess({data}) {
      this.body = data;
    },

    /**
     * @param data
     * @param status
     * @return {boolean}
     */
    handleErrorResponse({response: {data, status}}) {
      const {errors, message} = data || {};
      if (status === 422 && errors) {
        this.errors = errors;
        this.$refs.form.validate(() => null);
        this.$message.error(message);
      } else if (message && _.isString(message)) {
        this.$message.error(message);
      }

      this.close();
      return false;
    },

    /**
     * @return {Object}
     */
    getForm() {
      return _.assign({}, this.form, {
        _method: 'POST',
        email_message_id: _.get(this.message, 'email_message.id'),
      });
    },

    /**
     * @return {undefined}
     */
    close() {
      this.body = this.message = this.url = null;
    },
  },

  /**
   * @return {undefined}
   */
  created() {
    eventBus.$on('on-show-original-email-message', this.onShow);
  },

  /**
   * @return {undefined}
   */
  beforeDestroy() {
    eventBus.$off('on-show-original-email-message', this.onShow);
  },
}
</script>

<style scoped>

</style>
